import axios from 'axios'
import { API_URL } from '../utils/constants'

/**
 * Production / preview: call the configured API host directly.
 * Development: use same-origin `/api` so Vite's proxy reaches the backend (see vite.config.js).
 * Set VITE_USE_API_PROXY=false to force direct URL in dev (e.g. debugging CORS).
 */
function resolveApiBaseUrl() {
  const directBase = (() => {
    const raw = (API_URL || 'http://127.0.0.1:3000').replace(/\/$/, '')
    return raw.endsWith('/api') ? raw : `${raw}/api`
  })()

  if (import.meta.env.DEV && import.meta.env.VITE_USE_API_PROXY !== 'false') {
    return '/api'
  }
  return directBase
}

const baseURL = resolveApiBaseUrl()

const api = axios.create({
  baseURL,
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor: add admin key for /admin/* routes (from env)
api.interceptors.request.use(
  (config) => {
    const url = config.url || ''
    if (url.includes('/admin/')) {
      const adminKey = import.meta.env.VITE_ADMIN_KEY
      if (adminKey) config.headers['X-Admin-Key'] = adminKey
    }
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor
api.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token')
    }
    return Promise.reject(error)
  }
)

export default api
